import React from "react";
import {
  IFormProviderProps,
  IFormState,
  IOnlineAccountHolderDetails,
  IVisibleBlocksState,
} from "./types";
import { AlertTones } from "@origin-digital/ods-types";
import { ErrorTypeEnum } from "src/components/Form/types";
import {
  defaultFormState,
  defaultVisibleBlocks,
  defaultBlocksExpanded,
} from "./const";
import { FormContext } from "./context";

export const FormProvider: React.FC<IFormProviderProps> = ({
  children,
  initialFormState,
  initialVisibleBlocks,
  initialBlocksExpanded,
}) => {
  const [formState, setFormState] = React.useState<IFormState>({
    ...defaultFormState,
    ...initialFormState,
  });
  const [visibleBlocks, setVisibleBlocks] = React.useState<IVisibleBlocksState>(
    {
      ...defaultVisibleBlocks,
      ...initialVisibleBlocks,
    }
  );
  const [blocksExpanded, setBlocksExpanded] =
    React.useState<IVisibleBlocksState>({
      ...defaultBlocksExpanded,
      ...initialBlocksExpanded,
    });
  const [sidebarStatus, setSidebarStatus] = React.useState<
    Record<string, "warning" | "error" | undefined>
  >({});
  const [currentlyActiveBlock, setCurrentlyActiveBlock] =
    React.useState("premiseBlock");
  const [displayingSnackbar, setDisplayingSnackbar] = React.useState<{
    message: string;
    tone: AlertTones;
  } | null>(null);
  const [requestDetailsLoaded, setRequestDetailsLoaded] = React.useState(false);
  const [displayingAlertBanner, setDisplayingAlertBanner] =
    React.useState<ErrorTypeEnum | null>(null);

  const [messageScrollingBlockRefId, setMessageScrollingBlockRefId] =
    React.useState<string | undefined>(undefined);

  const [onlineAccountHolderDetails, setOnlineAccountHolderDetails] =
    React.useState<IOnlineAccountHolderDetails>({});

  // The value that will be passed to the context consumers
  const contextValue = {
    formState,
    visibleBlocks,
    currentlyActiveBlock,
    blocksExpanded,
    setFormState,
    setVisibleBlocks,
    setCurrentlyActiveBlock,
    setBlocksExpanded,
    displayingSnackbar,
    setDisplayingSnackbar,
    displayingAlertBanner,
    setDisplayingAlertBanner,
    messageScrollingBlockRefId,
    setMessageScrollingBlockRefId,
    requestDetailsLoaded,
    setRequestDetailsLoaded,
    sidebarStatus,
    setSidebarStatus,
    onlineAccountHolderDetails,
    setOnlineAccountHolderDetails,
  };

  return (
    <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>
  );
};
